"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobSearchResponseSchema = exports.JobSearchResultSchema = exports.JobDetailResponseSchema = exports.JobDetailResultSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../schemas");
const JobDetailSchema = schemas_1.JobPostingSchema.extend({
    company: schemas_1.CompanyProfileSchema.pick({
        description: true,
        capital: true,
        ceo: true,
        location: true,
        name: true,
        website: true,
    }),
    hasApplied: zod_1.z.boolean(),
    hasSaved: zod_1.z.boolean(),
});
exports.JobDetailResultSchema = zod_1.z.object({ job: JobDetailSchema });
exports.JobDetailResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.JobDetailResultSchema);
const JobSearchSchema = JobDetailSchema.pick({
    description: true,
    summary: true,
    company: true,
    coverImage: true,
    estimatedSalaryMax: true,
    estimatedSalaryMin: true,
    expiredAt: true,
    hasApplied: true,
    hasSaved: true,
    id: true,
    postedAt: true,
    qualification: true,
    title: true,
    workHours: true,
}).extend({ location: schemas_1.LocationBaseSchema });
exports.JobSearchResultSchema = zod_1.z.object({ jobs: JobSearchSchema.array() }).merge(schemas_1.PaginationResponseSchema);
exports.JobSearchResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.JobSearchResultSchema);
